import * as React from "react";

function SvgDinoWink(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 896 797"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      {...props}
    >
      <g transform="matrix(.96237 0 0 .96247 -612.126 -1274.172)">
        <circle cx={1057.35} cy={1737.7} r={413.85} fill="#ffeee9" />
        <clipPath id="dino_wink_svg___clip1">
          <circle cx={1057.35} cy={1737.7} r={413.85} />
        </clipPath>
        <g clipPath="url(#dino_wink_svg___clip1)">
          <g transform="matrix(-1.43049 0 0 1.43034 1835.12 1060.95)">
            <g transform="matrix(-1.17736 0 0 1.17736 1164.08 -123.566)">
              <path
                d="M372.825 533.416c21.258-10.202-10.559 173.71-10.559 197.289 0 23.579-19.143 42.723-42.722 42.723-23.58 0-42.526-19.145-42.723-42.723-.444-77.091 52.425-176.377 96.004-197.289z"
                fill="#fe9e9b"
              />
              <clipPath id="dino_wink_svg___clip2">
                <path d="M372.825 533.416c21.258-10.202-10.559 173.71-10.559 197.289 0 23.579-19.143 42.723-42.722 42.723-23.58 0-42.526-19.145-42.723-42.723-.444-77.091 52.425-176.377 96.004-197.289z" />
              </clipPath>
              <g clipPath="url(#dino_wink_svg___clip2)">
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8b88"
                  transform="matrix(.39321 .24704 -.29062 .46258 212.856 187.004)"
                />
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8b88"
                  transform="matrix(.2241 .06077 -.048 .177 170.009 555.049)"
                />
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8b88"
                  transform="matrix(.24234 .06571 -.07491 .27626 229.453 356.586)"
                />
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8b88"
                  transform="matrix(.14998 .04067 -.04444 .16388 265.317 417.922)"
                />
              </g>
            </g>
            <g transform="translate(-76.315 -123.566) scale(1.17736)">
              <path
                d="M372.825 533.416c21.258-10.202-10.559 173.71-10.559 197.289 0 23.579-19.143 42.723-42.722 42.723-23.58 0-42.526-19.145-42.723-42.723-.444-77.091 52.425-176.377 96.004-197.289z"
                fill="#fe9e9b"
              />
              <clipPath id="dino_wink_svg___clip3">
                <path d="M372.825 533.416c21.258-10.202-10.559 173.71-10.559 197.289 0 23.579-19.143 42.723-42.722 42.723-23.58 0-42.526-19.145-42.723-42.723-.444-77.091 52.425-176.377 96.004-197.289z" />
              </clipPath>
              <g clipPath="url(#dino_wink_svg___clip3)">
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8b88"
                  transform="matrix(-.48761 .36598 .3123 .4161 443.489 44.262)"
                />
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8b88"
                  transform="matrix(-.19964 .14984 .16154 .21523 344.773 379.246)"
                />
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8b88"
                  transform="matrix(-.2535 .19027 .23636 .31491 310.487 391.509)"
                />
              </g>
            </g>
            <path
              d="M454.922 405.876c-4.82-17.995 20.763-48.398 29.128-53.652 8.334-5.234 25.92 13.185 21.066 22.128-4.855 8.941-48.455 36.44-50.194 31.524z"
              fill="#fd6b67"
            />
            <path
              d="M480.736 391.034c-1.97-7.747 27.087-62.892 52.264-64.544 11.065-.726 20.53 35.72 11.819 46.478-8.71 10.756-62.113 25.813-64.083 18.066z"
              fill="#fd6b67"
            />
            <path
              d="M750.852 777.401c-10.707 70.062-406.486 69.456-415.076 0-10.189-82.382-3.493-186.567 1.556-214.876 18.487-103.632 100.716-192.791 205.982-193.322 105.266.531 187.495 89.69 205.981 193.322 5.05 28.309 14.097 132.819 1.557 214.876z"
              fill="#feb4b2"
            />
            <clipPath id="dino_wink_svg___clip4">
              <path d="M750.852 777.401c-10.707 70.062-406.486 69.456-415.076 0-10.189-82.382-3.493-186.567 1.556-214.876 18.487-103.632 100.716-192.791 205.982-193.322 105.266.531 187.495 89.69 205.981 193.322 5.05 28.309 14.097 132.819 1.557 214.876z" />
            </clipPath>
            <g clipPath="url(#dino_wink_svg___clip4)">
              <ellipse
                cx={360.123}
                cy={778.252}
                rx={39.216}
                ry={31.424}
                fill="#fea5a3"
              />
              <ellipse
                cx={393.895}
                cy={732.103}
                rx={14.973}
                ry={14.725}
                fill="#fea5a3"
                transform="matrix(.8931 .22682 -.18934 .74549 179.578 100.094)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fea5a3"
                transform="matrix(.84424 -.20693 .23195 .94633 -59.415 188.542)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fea5a3"
                transform="matrix(.84711 .04306 -.0492 .96801 82.8 -308.915)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fea5a3"
                transform="matrix(.34226 .10427 -.0859 .28195 504.375 487.89)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fea5a3"
                transform="matrix(.25025 -.12328 .13025 .2644 398.112 508.517)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fea5a3"
                transform="matrix(-.06356 .1502 -.17332 -.07334 823.797 676.675)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fea5a3"
                transform="matrix(-.13102 .09712 -.10695 -.14428 545.206 709.712)"
              />
              <ellipse
                cx={522.817}
                cy={430.672}
                rx={20.488}
                ry={28.446}
                fill="#fea5a3"
                transform="rotate(-37.754 520.875 443.7)"
              />
              <ellipse
                cx={451.534}
                cy={438.87}
                rx={15.874}
                ry={8.198}
                fill="#fea5a3"
                transform="rotate(-22.303 451.535 438.869)"
              />
            </g>
            <path
              d="M519.05 370.398c-6.132 14.619 25.332 59.94 36.567 53.7 11.234-6.238 43.898-65.617 23.883-89.697-12-14.436-52.788 17.732-60.45 35.997z"
              fill="#fd6b67"
            />
            <path d="M695.888 523.5c8.22 1.203 17.462-5.742 17.7-4.637 1.409 6.52-5.526 17.512-11.613 22.39l-6.087-17.753z" />
            <circle
              cx={427.545}
              cy={531.3}
              r={27.325}
              transform="translate(229.051 -15.274) scale(1.04746)"
            />
            <circle
              cx={437.886}
              cy={527.93}
              r={10.341}
              fill="#fff"
              transform="translate(225.755 -15.851) scale(1.04746)"
            />
            <g>
              <path
                d="M593.983 558.266c-8.485 5.813-18.446 9.868-29.102 12.049a95.629 95.629 0 01-20.97 1.91c-17.842-.35-35.733-5.394-50.168-13.727a2.051 2.051 0 01-.801-2.783 2.052 2.052 0 012.783-.804c14.051 7.406 31.269 11.07 48.275 11.237 6.702.066 13.378-.358 19.846-1.424 10.106-1.669 19.723-4.747 28.02-9.752a1.958 1.958 0 112.118 3.294z"
                fill="#b64646"
              />
            </g>
            <g>
              <path d="M389.263 529.375c-8.135 1.714-17.8-4.646-17.969-3.528-1 6.6 6.612 17.148 12.997 21.64l4.972-18.112z" />
              <path d="M440.35 546.861c-2.963-7.934-8.024-13.825-13.86-17.584-4.252-2.755-8.954-4.253-13.58-4.481a23.445 23.445 0 00-6.914.68c-2.21.553-4.355 1.402-6.36 2.647-2.85 1.752-5.455 4.18-7.635 7.443-1.906 2.866-3.587 6.25-4.771 10.318a2.113 2.113 0 01-2.506 1.598 2.1 2.1 0 01-1.589-2.506c.912-5.87 2.734-10.733 5.203-14.677a27.505 27.505 0 017.462-7.946 25.091 25.091 0 018.413-3.909c2.981-.77 6.101-.982 9.201-.698 4.387.408 8.78 1.784 12.842 4.138 7.935 4.59 14.693 12.723 17.73 23.804a1.908 1.908 0 01-1.237 2.4 1.91 1.91 0 01-2.4-1.227z" />
            </g>
          </g>
        </g>
      </g>
      <path
        d="M265.24 970.652c25.212-82.597 81.542-156.433 163.721-209.123"
        fill="none"
        stroke="#bcdad1"
        strokeWidth={10.6}
        transform="matrix(-.75512 -.12764 -.12385 .73273 1089.667 -423.488)"
      />
      <path
        d="M642.866 57.462c-2.113 2.675 6.055 12.263 14.256 18.417 8.201 6.154 13.35 6.56 15.464 3.885 2.113-2.675.396-7.423-7.806-13.577-8.2-6.154-19.8-11.4-21.914-8.725zM660.536 99.247c-.827 3.247 11.923 9.232 23.06 12.011 11.136 2.78 16.54-.935 17.366-4.182.827-3.246-3.234-4.803-14.37-7.582-11.137-2.78-25.23-3.493-26.056-.247zM686.327 140.909c-.804 3.7 13.67 9.682 26.222 12.152 12.552 2.47 18.454-2.026 19.258-5.727.804-3.701-3.793-5.213-16.345-7.683-12.552-2.47-28.331-2.443-29.135 1.258zM706.154 177.843c-2.513 4.592 11.193 16.466 24.258 23.224 13.067 6.76 21.67 2.568 24.183-2.025 2.514-4.592-2.008-7.858-15.074-14.617-13.066-6.758-30.854-11.174-33.367-6.582z"
        fill="#bcdad1"
      />
      <path
        d="M773.718 149.556c4.76 1.576 3.32 19.166-1.084 32.7-4.403 13.533-13.042 16.314-17.803 14.738-4.761-1.577-3.853-6.918.55-20.452 4.404-13.533 13.576-28.563 18.337-26.986zM800.465 214.276c4.457 2.409-.808 20.088-8.179 33.135-7.371 13.047-16.681 14.424-21.14 12.015-4.457-2.41-2.384-7.698 4.988-20.745 7.37-13.047 19.873-26.814 24.33-24.405z"
        fill="#bcdad1"
      />
      <path
        d="M727.66 228.272c-3.386 3.918 7.907 18.52 19.56 27.996 11.653 9.477 21.005 7.298 24.392 3.38 3.387-3.918-.465-8.1-12.119-17.577-11.652-9.477-28.445-17.717-31.833-13.799zM731.082 98.822c3.848-.085 7.649 15.531 8.21 28.546.562 13.016-4.869 18.038-8.717 18.123-3.848.085-4.665-4.8-5.226-17.815-.562-13.015 1.885-28.77 5.733-28.854zM690.106 66.486c3.286-.985 10.146 11.06 13.623 21.717 3.478 10.658-.033 16.113-3.32 17.097-3.287.985-5.112-2.87-8.59-13.529-3.478-10.657-5-24.3-1.713-25.285z"
        fill="#bcdad1"
      />
      <g>
        <path
          d="M291.451 899.885c28.694-54.334 75.401-101.864 137.51-138.356"
          fill="none"
          stroke="#bcdad1"
          strokeWidth={8.61}
          transform="matrix(-.32146 -.87187 -.87187 .32146 1669.482 452.052)"
        />
        <path
          d="M875.1 271.418c-4.41-.601-10.374 16.404-12.352 30.92-1.978 14.515.774 21.08 5.184 21.681 4.411.601 8.82-4.988 10.798-19.504 1.978-14.515.781-32.496-3.63-33.097zM840.42 322.837c-4.032 1.132-2.767 18.214.998 31.625 3.767 13.412 11.097 16.798 15.13 15.666 4.032-1.133 3.249-6.358-.517-19.77-3.766-13.41-11.579-28.653-15.611-27.521zM825.524 378.34c-4.718 0-8.55 18.773-8.551 34.35-.002 15.577 6.916 21.44 11.635 21.44 4.718 0 5.46-5.862 5.461-21.44.002-15.576-3.827-34.349-8.545-34.35zM789.453 426.327c-5.014-.464-11.079 20.697-12.733 38.567-1.654 17.872 5.077 25.278 10.092 25.742 5.015.464 6.426-6.188 8.08-24.06 1.654-17.87-.424-39.784-5.44-40.249z"
          fill="#bcdad1"
        />
        <path
          d="M849.638 468.264c1.995 4.232-15.78 16.812-31.873 24.398-16.095 7.587-25.077 4.235-27.073.002-1.995-4.233 3.748-7.753 19.842-15.34 16.093-7.587 37.109-13.293 39.104-9.06zM877.02 399.707c3.167 3.459-8.679 19.465-20.641 30.416-11.963 10.952-21.108 10-24.275 6.541-3.167-3.46.837-8.124 12.8-19.076 11.962-10.95 28.95-21.34 32.116-17.88zM895.086 335.6c3.073 2.846-5.838 17.474-15.302 27.695-9.465 10.221-17.533 9.895-20.607 7.049-3.073-2.846.006-7.14 9.47-17.361s23.366-20.229 26.439-17.383z"
          fill="#bcdad1"
        />
        <g>
          <path
            d="M258.694 1046.24c-5.263-114.531 56.797-218.043 170.267-284.711"
            fill="none"
            stroke="#66a09e"
            strokeWidth={8.32}
            transform="matrix(-.93313 -.2325 -.2325 .93313 1275.477 -414.938)"
          />
          <path
            d="M670.691 170.043c-2.93 3.256 4.297 14.548 12.27 21.724 7.972 7.177 13.69 7.537 16.62 4.28 2.932-3.256 1.974-8.904-5.998-16.08-7.973-7.176-19.96-13.18-22.892-9.924zM686.053 221.939c-1.893 5.641 11.358 15.183 23.628 19.3 12.271 4.116 19.664-2.609 21.557-8.251 1.893-5.643-2.427-8.079-14.698-12.195-12.27-4.117-28.594-4.497-30.487 1.146zM716.297 269.546c-2.671 5.39 11.855 18.04 25.707 24.903 13.854 6.863 22.984 1.54 25.655-3.852 2.672-5.393-2.121-8.823-15.975-15.687-13.852-6.863-32.716-10.757-35.387-5.364zM734.527 327.847c-3.292 5.816 13.514 21.565 29.677 30.714 16.164 9.15 27.075 4.064 30.368-1.754 3.293-5.817-2.272-10.175-18.436-19.324-16.163-9.15-38.316-15.453-41.609-9.636z"
            fill="#66a09e"
          />
          <path
            d="M825.478 300.292c5.971 2.76 1.508 25.144-6.218 41.857-7.727 16.714-19.392 18.955-25.364 16.194-5.972-2.76-4.004-9.484 3.723-26.198 7.726-16.713 21.886-34.614 27.859-31.853zM846.666 383.195c5.27 4.048-3.971 24.932-15.188 39.533-11.218 14.602-23.168 14.16-28.438 10.11-5.27-4.048-1.877-10.18 9.34-24.781 11.218-14.601 29.016-28.911 34.286-24.862z"
            fill="#66a09e"
          />
          <path
            d="M743.008 385.714c-3.966 4.702 11.598 24.364 27.184 37.51 15.587 13.148 27.269 11.2 31.235 6.497 3.967-4.703-1.275-10.39-16.862-23.537-15.586-13.146-37.59-25.172-41.557-20.47zM742.104 445.861c-5.566 4.371 5.857 28.222 19.086 45.066 13.229 16.846 26.37 16.775 31.938 12.403 5.567-4.372 1.464-11.399-11.766-28.244-13.228-16.845-33.69-33.597-39.258-29.225z"
            fill="#66a09e"
          />
          <path
            d="M859.652 476.53c3.283 7.494-17.673 23.928-37.274 32.515-19.601 8.587-31.793.827-35.076-6.67-3.284-7.495 3.576-11.905 23.177-20.492 19.6-8.587 45.889-12.85 49.173-5.353zM779.064 227.666c5.71.344 9.134 20.75 8.127 37.45-1.007 16.702-9.76 22.482-15.472 22.137-5.712-.344-6.231-6.683-5.224-23.384 1.007-16.7 6.858-36.548 12.57-36.203zM736.515 187.125c5.292.736 7.58 15.796 5.913 27.797-1.667 12.002-10.056 15.44-15.35 14.705-5.293-.735-5.498-5.367-3.83-17.37 1.666-12 7.973-25.867 13.267-25.132z"
            fill="#66a09e"
          />
        </g>
      </g>
      <g>
        <path
          d="M265.24 970.652c18.833-83.804 75.869-157.506 163.721-209.123"
          fill="none"
          stroke="#bcdad1"
          strokeWidth={7.16}
          transform="matrix(.46292 -1.01733 1.01733 .46292 -891.051 568.55)"
        />
        <path
          d="M76.79 412.836c5.082-.314 10.712 23.79 11.96 44 1.247 20.213-2.358 28.93-7.44 29.243-5.083.314-9.732-7.893-10.98-28.105-1.247-20.212 1.377-44.825 6.46-45.138zM117.955 478.613c4.736 1.716.673 24.941-5.89 43.057-6.562 18.116-15.978 22.417-20.715 20.701-4.737-1.716-3.011-8.803 3.551-26.92 6.563-18.115 18.318-38.554 23.054-36.838zM128.685 543.476c5.658.418 8.305 27.144 6.688 49.04-1.617 21.895-10.524 29.522-16.184 29.104-5.66-.417-5.94-8.723-4.324-30.62 1.617-21.894 8.16-47.942 13.82-47.524zM166.848 615.734c6.056-.112 11.454 25.808 11.853 47.391.4 21.584-8.331 29.87-14.388 29.983-6.057.112-7.16-7.993-7.558-29.577-.4-21.583 4.037-47.685 10.093-47.797z"
          fill="#bcdad1"
        />
        <path
          d="M90.935 660.7c-2.768 4.9 17.438 21.567 36.07 32.094 18.632 10.528 29.704 7.304 32.473 2.403 2.77-4.901-3.807-9.633-22.44-20.161-18.631-10.527-43.334-19.236-46.103-14.335zM145.802 748.63c-.504 5.606 24.774 12.468 46.088 14.385 21.315 1.918 30.075-5.581 30.58-11.187.504-5.607-7.438-7.21-28.753-9.127-21.314-1.918-47.41.323-47.915 5.93z"
          fill="#bcdad1"
        />
        <path
          d="M199.916 679.247c5.255-2.016 18.758 20.428 26.421 40.409 7.664 19.982 2.842 30.457-2.414 32.473-5.255 2.016-8.966-5.187-16.63-25.169-7.663-19.98-12.632-45.698-7.377-47.713zM58.722 570.256c-4.105 3.868 10.518 26.063 25.416 41.874 14.9 15.812 26.526 16.089 30.632 12.22 4.106-3.869-.856-10.427-15.755-26.239-14.899-15.81-36.187-31.724-40.293-27.855zM39.054 486.088c-3.939 3.14 8.525 25.33 21.52 41.626 12.996 16.297 23.662 17.824 27.601 14.683 3.94-3.142-.332-9.768-13.328-26.065-12.995-16.296-31.854-33.385-35.793-30.244z"
          fill="#bcdad1"
        />
        <g>
          <path
            d="M265.24 970.652c18.833-83.804 75.869-157.506 163.721-209.123"
            fill="none"
            stroke="#66a09e"
            strokeWidth={9.42}
            transform="matrix(-.1303 -.83905 .83905 -.1303 -557.346 1098.205)"
          />
          <path
            d="M.86 607.15c3.096-2.318 13.876 6.837 20.734 15.996 6.858 9.16 7.216 14.877 4.12 17.195-3.098 2.32-8.483.367-15.342-8.792-6.858-9.16-12.61-22.08-9.512-24.399zM47.45 626.968c3.723-.885 10.296 13.32 13.241 25.702 2.946 12.383-1.405 18.342-5.129 19.228-3.723.886-5.417-3.635-8.363-16.019-2.945-12.382-3.472-28.025.251-28.91zM83.986 664.686c3.768-2.095 15.162 11.197 22.078 23.637 6.916 12.441 3.993 20.194.225 22.29-3.768 2.094-6.963-2.258-13.88-14.7-6.915-12.44-12.19-29.133-8.423-31.227zM134.098 687c3.798-2.597 18.035 11.61 27.29 25.15 9.254 13.539 7.166 22.442 3.366 25.039-3.8 2.597-7.879-2.09-17.133-15.63-9.254-13.538-17.323-31.963-13.523-34.56z"
            fill="#66a09e"
          />
          <path
            d="M104.645 747.21c.285 4.266 20.066 6.423 36.288 5.338 16.222-1.085 21.908-7.75 21.622-12.017-.285-4.266-6.434-4.529-22.656-3.444-16.222 1.085-35.54 5.857-35.254 10.124zM176.154 780.165c2.017 3.77 20.93-2.414 35.265-10.085 14.334-7.671 16.77-16.087 14.752-19.857-2.017-3.77-7.729-1.476-22.064 6.195-14.334 7.67-29.97 19.976-27.953 23.747z"
            fill="#66a09e"
          />
          <path
            d="M181.582 713.54c2.496-3.472 20.43 5.15 33.629 14.641 13.2 9.493 14.506 18.155 12.009 21.627-2.497 3.472-7.856.445-21.056-9.047-13.199-9.492-27.079-23.75-24.582-27.222zM52.342 704.61c-.994 4.169 15.572 11.695 29.988 15.13 14.416 3.437 21.298-1.383 22.292-5.552.994-4.168-4.275-6.117-18.691-9.553-14.416-3.436-32.596-4.193-33.59-.024zM9.455 661.43c-1.191 3.636 12.42 11.364 24.516 15.326 12.096 3.962 18.395.12 19.587-3.518 1.19-3.637-3.174-5.7-15.27-9.662-12.097-3.962-27.642-5.784-28.833-2.147z"
            fill="#66a09e"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgDinoWink;
